export const SEARCH_BET_BY_USERNAME_AND_AMOUNT_REQUEST = 'SEARCH_BET_BY_USERNAME_AND_AMOUNT_REQUEST';
export const SEARCH_BET_BY_USERNAME_AND_AMOUNT_SUCCESS = 'SEARCH_BET_BY_USERNAME_AND_AMOUNT_SUCCESS';
export const SEARCH_BET_BY_USERNAME_AND_AMOUNT_FAIL = 'SEARCH_BET_BY_USERNAME_AND_AMOUNT_FAIL';
export const CLEAR_BET_BY_USERNAME = 'CLEAR_BET_BY_USERNAME';

export const SEARCH_BET_BY_BET_AND_AMOUNT_REQUEST = 'SEARCH_BET_BY_BET_AND_AMOUNT_REQUEST';
export const SEARCH_BET_BY_BET_AND_AMOUNT_SUCCESS = 'SEARCH_BET_BY_BET_AND_AMOUNT_SUCCESS';
export const SEARCH_BET_BY_BET_AND_AMOUNT_FAIL = 'SEARCH_BET_BY_BET_AND_AMOUNT_FAIL';
export const CLEAR_BET_BY_MATCH = 'CLEAR_BET_BY_MATCH';